import axios from 'axios';
import api from '@src/api';
import cloneDeep from 'lodash/cloneDeep';

export const state = {
  allExercises: [],
  allExercisesTrueSource: [],
  exerciseDetails: {},
  exerciseModel: null,
  selectedExercise: null,
  selectedAltExercise: null,
  selectedStep: null,
  exerciseStep: null,
  hasUnsavedExerciseChanges: false,
  exerciseFilter: {},
};

export const getters = {
  exerciseMap: (state) => {
    const map = {};
    if (state.allExercises.length) {
      state.allExercises.forEach((exercise) => {
        map[exercise._id] = exercise;
      });
    }
    return map;
  },
  exerciseLabelMap: (state) => {
    const map = {};
    if (state.allExercises) {
      state.allExercises.forEach((exercise) => {
        map[exercise.label] = exercise;
      });
    }
    return map;
  },
  exerciseIdMap: (state) => {
    const map = {};
    if (state.allExercises) {
      state.allExercises.forEach((exercise) => {
        map[exercise._id] = exercise;
      });
    }
    return map;
  },
  exerciseTrainerMap: (state) => {
    const map = {};
    if (state.allExercises) {
      state.allExercises.forEach((exercise) => {
        if (!map[exercise.trainer_id]) {
          map[exercise.trainer_id] = [];
        }
        map[exercise.trainer_id].push(exercise);
      });
    }
    return map;
  },
  hasUnsavedExerciseChanges: (state) => {
    return state.hasUnsavedExerciseChanges;
  },
};

export const mutations = {
  setAllExercises(state, value) {
    state.allExercises = value;
  },
  setHasUnsavedExerciseChanges(state, value) {
    state.hasUnsavedExerciseChanges = value;
  },
  setAllExercisesTrueSource(state, value) {
    state.allExercisesTrueSource = value;
  },
  setCreateExercise(state, value) {
    state.allExercises.unshift(value);
  },
  setExerciseDetails(state, value) {
    const clone = cloneDeep(state.exerciseDetails);
    clone[value._id] = value;
    state.exerciseDetails = clone;
  },
  setSelectedExercise(state, value) {
    state.selectedExercise = value;
  },
  setSelectedAltExercise(state, value) {
    state.selectedAltExercise = value;
  },
  setSelectedStep(state, value) {
    state.selectedStep = value;
  },
  setUpdateExerciseTitle(state, value) {
    const exerciseClone = cloneDeep(state.selectedExercise);
    exerciseClone.label = value;
    state.selectedExercise = exerciseClone;
  },
  setUpdateExercise(state, value) {
    const i = state.allExercises.findIndex(
      (exercise) => exercise._id === value._id
    );
    state.allExercises[i] = value;

    const j = state.allExercisesTrueSource.findIndex(
      (exercise) => exercise._id === value._id
    );
    state.allExercisesTrueSource[j] = value;
  },
  setRemoveExerciseMuscleGroup(state, value) {
    const i = state.selectedExercise.muscleGroups.findIndex(
      (item) => item.muscleGroup_id === value
    );
    state.selectedExercise.muscleGroups.splice(i, 1);
  },
  setDeleteExerciseItem(state, value) {
    const allExercisesClone = cloneDeep(state.allExercises);
    const i = state.allExercises.findIndex((item) => item._id === value._id);
    if (i > -1) {
      allExercisesClone.splice(i, 1);
      state.allExercises = allExercisesClone;
    }

    const allExercisesTrueSourceClone = cloneDeep(state.allExercisesTrueSource);
    const j = state.allExercisesTrueSource.findIndex(
      (item) => item._id === value._id
    );
    if (j > -1) {
      allExercisesTrueSourceClone.splice(j, 1);
      state.allExercisesTrueSource = allExercisesTrueSourceClone;
    }
  },
  setRemoveWeightedEquip(state) {
    state.selectedExercise.requiredEquipment.weighted = null;
  },
  setRemoveUnweightedEquip(state, value) {
    const i = state.selectedExercise.requiredEquipment.unweighted.findIndex(
      (item) => item._id === value._id
    );
    state.selectedExercise.requiredEquipment.unweighted.splice(i, 1);
  },
  setAddStep(state, value) {
    const exerciseClone = cloneDeep(state.selectedExercise);
    exerciseClone.steps.push(value);
    state.selectedExercise = exerciseClone;
  },
  setUpdateStep(state, value) {
    const exerciseClone = cloneDeep(state.selectedExercise);
    exerciseClone.steps[value.index] = value.step;
    state.selectedExercise = exerciseClone;
  },
  setRemoveStep(state, value) {
    const exerciseClone = cloneDeep(state.selectedExercise);
    exerciseClone.steps.splice(value, 1);
    state.selectedExercise = exerciseClone;
  },
  setMoveStepUp(state, value) {
    const exerciseClone = cloneDeep(state.selectedExercise);
    const prevIndex = value.index - 1;
    const prevStep = exerciseClone.steps[prevIndex];
    const currStep = exerciseClone.steps[value.index];
    prevStep.order = prevStep.order + 1;
    currStep.order = currStep.order - 1;
    state.selectedExercise.steps = swapSteps(
      exerciseClone.steps,
      value.index,
      prevIndex
    );
  },
  setMoveStepDown(state, value) {
    const exerciseClone = cloneDeep(state.selectedExercise);
    const nextIndex = value.index + 1;
    const nextStep = exerciseClone.steps[nextIndex];
    const currStep = exerciseClone.steps[value.index];
    nextStep.order = nextStep.order - 1;
    currStep.order = currStep.order + 1;
    state.selectedExercise.steps = swapSteps(
      exerciseClone.steps,
      value.index,
      nextIndex
    );
  },
  setExerciseModel(state, value) {
    state.exerciseModel = value;
  },
  setExercisesFilter(state, value) {
    state.exerciseFilter = value;
  },
};

export const actions = {
  getAllExercises(ctx, { orgId, trainerId }) {
    if (orgId !== undefined) {
      const url = api.URL_GET_ALL_EXERCISE.replace(':orgID', orgId);

      return axios
        .get(url)
        .then((res) => {
          ctx.commit('setAllExercises', res.data.exercises);
          ctx.commit('setAllExercisesTrueSource', res.data.exercises);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (orgId, trainerId) : (${orgId}, ${trainerId})`
      );
    }
  },

  getExercise(ctx, { exerciseId, orgId, trainerId }) {
    if (
      exerciseId !== undefined &&
      orgId !== undefined &&
      trainerId !== undefined
    ) {
      if (!ctx.state.exerciseDetails[exerciseId]) {
        const url = api.URL_GET_EXERCISE.replace(':exerciseID', exerciseId)
          .replace(':orgID', orgId)
          .replace(':trainerID', trainerId);

        return axios
          .get(url)
          .then((res) => {
            ctx.commit('setExerciseDetails', res.data.exercise);
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        return ctx.state.exerciseDetails[exerciseId];
      }
    } else {
      console.error(
        `invalid params (exerciseId, orgId, trainerId) : (${exerciseId}, ${orgId}, ${trainerId})`
      );
    }
  },

  createExercise(ctx, { exerciseObj }) {
    if (exerciseObj !== undefined) {
      const url = api.URL_CREATE_EXERCISE.replace(
        ':trainerID',
        exerciseObj.trainer_id
      ).replace(':orgID', exerciseObj.org_id);

      // Minimum data check for creating a new piece of exercise
      if (
        exerciseObj.trainer_id !== undefined &&
        exerciseObj.org_id !== undefined &&
        exerciseObj.label !== undefined &&
        exerciseObj.exerciseDifficulty !== undefined &&
        exerciseObj.muscleGroups !== undefined
      ) {
        if (!exerciseObj.description) {
          exerciseObj.description = '';
        }

        const requestPayload = { exercise: exerciseObj };
        return axios
          .put(url, requestPayload)
          .then((res) => {
            ctx.commit('setCreateExercise', res.data.exercise);
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'exerciseObj must contain the following properties [trainer_id, org_id, label, exerciseDifficulty, muscleGroup]',
          exerciseObj
        );
      }
    } else {
      console.error(
        `invalid params (exerciseObj, trainer_id) : (${exerciseObj}, ${exerciseObj.trainer_id})`
      );
    }
  },

  updateExercise(ctx, { trainerId, exerciseId, exerciseObj, isReplacement }) {
    if (exerciseId !== undefined && exerciseObj !== undefined) {
      const url = api.URL_UPDATE_EXERCISE.replace(':exerciseID', exerciseId)
        .replace(':trainerID', trainerId)
        .replace(':orgID', exerciseObj.org_id);

      // minimum data check for creating a new piece of exercise
      if (
        !isReplacement ||
        (exerciseObj.trainer_id !== undefined &&
          exerciseObj.org_id !== undefined &&
          exerciseObj.label !== undefined &&
          exerciseObj.description !== undefined)
      ) {
        const requestPayload = { exercise: exerciseObj };
        return axios
          .post(url, requestPayload)
          .then((res) => {
            ctx.commit('setUpdateExercise', res.data.exercise);
            return res.data;
          })
          .catch((err) => {
            console.warn(err);
          });
      } else {
        console.error(
          'exerciseObj must contain the following properties to be a valid replacement [trainer_id, org_id, label, type, description]',
          exerciseObj
        );
      }
    } else {
      console.error(
        `invalid params (exerciseId, exerciseObj) : (${exerciseId}, ${exerciseObj})`
      );
    }
  },

  deleteExercise(ctx, { exerciseId, trainerId, orgId }) {
    if (
      exerciseId !== undefined &&
      trainerId !== undefined &&
      orgId !== undefined
    ) {
      const url = api.URL_DELETE_EXERCISE.replace(':exerciseID', exerciseId)
        .replace(':trainerID', trainerId)
        .replace(':orgID', orgId);

      return axios
        .delete(url)
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (exerciseId, trainerId, orgId) : (${exerciseId}, ${trainerId}, ${orgId})`
      );
    }
  },

  getExerciseShape(ctx, { orgId, trainerId }) {
    if (orgId !== undefined && trainerId !== undefined) {
      const url = api.URL_GET_EXERCISE_SHAPE.replace(':orgID', orgId).replace(
        ':trainerID',
        trainerId
      );

      return axios
        .get(url)
        .then((res) => {
          ctx.commit('setExerciseModel', res.data.exercise);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (orgId, trainerId) : (${orgId}, ${trainerId})`
      );
    }
  },
};

// Private Helpers

function swapSteps(arr, index1, index2) {
  [arr[index1], arr[index2]] = [arr[index2], arr[index1]];
  return arr;
}
